/**
 * @param value
 * @returns boolean
 */
export default function isNotNil<T>(value: T | null | undefined): value is T {
  return value != null
}
